import React, { useContext, useState } from 'react'
import { Modal, Box, Typography, FormControlLabel, Switch, Button } from '@mui/material'
import CookieIcon from '@mui/icons-material/Cookie'
import { CookieConsentContext } from '../../../contexts/CookieConsentContext'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
}

const CookieConsentModal = () => {
  const { isModalOpen, acceptCookies, partialConsent, toggleModal } =
    useContext(CookieConsentContext)
  const [analytics, setAnalytics] = useState(true)
  const [advertising, setAdvertising] = useState(true)

  const handlePartialConsent = () => {
    partialConsent(analytics, advertising)
  }

  return (
    <Modal open={isModalOpen} onClose={toggleModal}>
      <Box sx={style}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <CookieIcon color='primary' />
          <Typography variant='h5'>Usamos cookies no nosso site</Typography>
        </Box>
        <Typography sx={{ mb: 2, textAlign: 'justify' }}>
          Cookies são pequenos arquivos de texto que são armazenados no seu computador quando visita
          um site. Utilizamos cookies para diversos fins e para aprimorar sua experiência no nosso
          site (por exemplo, para se lembrar dos detalhes de login da sua conta).
        </Typography>
        {/* Switches de consentimento */}
        <Box sx={{ mb: 2 }}>
          <FormControlLabel control={<Switch checked disabled />} label='Cookies Obrigatórios' />
          <FormControlLabel
            control={<Switch checked={analytics} onChange={e => setAnalytics(e.target.checked)} />}
            label='Cookies de Analytics'
          />
          <FormControlLabel
            control={
              <Switch checked={advertising} onChange={e => setAdvertising(e.target.checked)} />
            }
            label='Cookies de Publicidade'
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={handlePartialConsent} variant='outlined'>
            Confirmar preferências
          </Button>
          <Button onClick={acceptCookies} variant='contained'>
            Permitir todos
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default CookieConsentModal
